import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { PagedResult } from '../../core/models/api.models';
import { BugCommentDto, BugDto } from './bugs.models';

@Injectable({ providedIn: 'root' })
export class BugsApiService {
  private readonly api = inject(ApiService);
  private readonly base = 'v1/bugs';

  list(params: { projectId?: string; page?: number; pageSize?: number } = {}): Observable<PagedResult<BugDto>> {
    return this.api.getPaged<BugDto>(this.base, {
      page: params.page ?? 1,
      pageSize: params.pageSize ?? 100,
      projectId: params.projectId
    });
  }

  getById(id: string): Observable<BugDto> {
    return this.api.get<BugDto>(`${this.base}/${id}`);
  }

  create(body: {
    projectId: string;
    title: string;
    description?: string;
    severity?: number;
    category?: number;
    relatedTaskId?: string;
    relatedIssueId?: string;
    stepsToReproduce?: string;
    environment?: string;
  }): Observable<BugDto> {
    return this.api.post<BugDto>(this.base, body);
  }

  update(id: string, body: {
    title?: string;
    description?: string;
    severity?: number;
    category?: number;
    status?: number;
    relatedTaskId?: string;
    relatedIssueId?: string;
    stepsToReproduce?: string;
    environment?: string;
  }): Observable<BugDto> {
    return this.api.put<BugDto>(`${this.base}/${id}`, body);
  }

  delete(id: string): Observable<unknown> {
    return this.api.delete(`${this.base}/${id}`);
  }

  listComments(bugId: string): Observable<BugCommentDto[]> {
    return this.api.get<BugCommentDto[]>(`${this.base}/${bugId}/comments`);
  }

  addComment(bugId: string, body: { authorId?: string; content: string }): Observable<BugCommentDto> {
    return this.api.post<BugCommentDto>(`${this.base}/${bugId}/comments`, body);
  }
}
